import React from "react";
import "./team.css";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { AiOutlineTwitter } from "react-icons/ai";
import Fade from "react-reveal/Fade";
import Image1 from "../../Image/team/president.jpg";
import Image2 from "../../Image/team/cassy.png";
import Image3 from "../../Image/team/joseph_eke.jpg";
import Image4 from "../../Image/team/samson_okolo.jpg";
import Image5 from "../../Image/team/MOSES.jpg";
import Image6 from "../../Image/team/elias_james.png";
import Image7 from "../../Image/team/augustine_amuta.png";
import Image8 from "../../Image/team/michael.jpg";

const Team = () => {
  const data = [
    {
      id: 1,
      name: "Sir George Zangir",
      content: "President & Founder",
      img: Image1,
    },
    {
      id: 2,
      name: "Lady Cassandra George",
      content: "Vice President & Co-Founder",
      img: Image2,
    },
    {
      id: 3,
      name: "Joseph Eke",
      content: "Accounts & Finance Manager",
      img: Image3,
    },
    {
      id: 4,
      name: "Samson Okolo",
      content: "Marketing Manager",
      img: Image4,
    },
    {
      id: 5,
      name: "Moses Igyuve",
      content: "Research & Development Manager",
      img: Image5,
    },
    {
      id: 6,
      name: "Elias James",
      content: "Head of ValuVeggies",
      img: Image6,
    },
    {
      id: 7,
      name: "Augustine Amuta",
      content: "Operations Manager",
      img: Image7,
    },
    {
      id: 8,
      name: "Michael Adebayo",
      content: "HR & Admin Manager",
      img: Image8,
    },
  ];

  return (
    <div className="container team-members" id="team">
      <div className="section_title">
        <h5>Management</h5>
        <span className="line"></span>
      </div>

      <div className="row">
        {data.map((item, index) => (
          <Fade right>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="card team-members-item">
                <img src={item.img} alt={item.name} />
                <div className="team-info">
                  <h6>{item.name}</h6>
                  <p>{item.content}</p>
                </div>
                <span className="line-for-teammebers"></span>

                <div className="social-icons">
                  <p>
                    <FaLinkedinIn size={25} />
                  </p>
                </div>
              </div>
            </div>
          </Fade>
        ))}
      </div>
    </div>
  );
};

export default Team;
